// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__KDtMc","modal":"Gallery_modal__Gqy5y","modal_content":"Gallery_modal_content__rW4nF"};